import { Component } from "@angular/core";

import { BaseDefaultOptionLayouts } from "../base/base-default-option-layouts.component";
import { AdHocOption } from "./ad-hoc-option";

@Component({
  template: `
    <ng-template taOptionLayout let-option>
      <span [className]="selectClasses.label">{{ option?.label }}</span>
    </ng-template>
  `
})
export class AdHocDefaultOptionLayoutsComponent<
  Identifier extends number | string
> extends BaseDefaultOptionLayouts<AdHocOption<Identifier>> {}
